export default __webpack_public_path__ + "static/media/img-store-machines.5b5c9feb.png";